import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/spotpris/se4")({
  head: () => seoHead("/spotpris/se4"),
  beforeLoad: () => permanentRedirect("/spotpris/elomrade-se4"),
});
